import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

// Hero slider
const heroSlider = new Swiper(".heroslider.swiper", {
  modules: [Autoplay, EffectFade, Navigation],
  fadeEffect: { crossFade: true },
  effect: "fade",
  virtualTranslate: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  speed: 1000,
  slidesPerView: 1,
  navigation: {
    enabled: true,
    nextEl: ".heroslider.swiper .swiper-button-next",
    prevEl: ".heroslider.swiper .swiper-button-prev",
  },
  on: {
    slideChangeTransitionStart: function () {
      const slides = document.querySelectorAll(".heroslider__content");

      slides.forEach((slide) => {
        slide.classList.remove("aos-animate");
      });
    },
    slideChangeTransitionEnd: function () {
      const activeSlideIndex = this.activeIndex;
      const slides = document.querySelectorAll(".heroslider__content");
      slides[activeSlideIndex].classList.add("aos-animate");
    },
  },
});

const realizationsSlider = new Swiper(".realizations-home .swiper", {
  modules: [Autoplay, Navigation],
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  speed: 1000,
  slidesPerView: "auto",
  spaceBetween: 52,
  navigation: {
    enabled: true,
    nextEl: ".realizations-home .swiper .swiper-button-next",
    prevEl: ".realizations-home .swiper .swiper-button-prev",
  },
});

const slider = new Swiper(".slider .swiper", {
  modules: [Autoplay, Pagination],
  autoplay: {
    delay: 4000,
    disableOnInteraction: true,
  },
  speed: 1000,
  pagination: {
    el: ".slider .swiper-pagination",
    clickable: true,
  },
  slidesPerView: "auto",
  spaceBetween: 32,
});
